export default "__VITE_ASSET__tbrMOuIQ__"